import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    borderCollapse: 'collapse',
    overflow: 'hidden',
    fontSize: theme.size.sm,
    '& > thead': {
      borderBottom: `solid 0.0625rem ${theme.palette.primary.main}`
    },
    '& > thead > tr': {
      height: 37
    },
    '& > thead > tr > td': {
      height: '100%',
      boxSizing: 'border-box'
    },

    '& > tbody > tr ': {
      display: 'flex',
      borderBottom: '0.0625rem solid rgba(230, 234, 236, 0.5)'
    },

    '& > tbody > tr > td': {
      width: 234,
      flexShrink: 0,
      padding: '0.5rem',
      display: 'flex',
      alignItems: 'center'
    }
  },

  row: {
    display: 'flex',
    alignItems: 'center'
  },

  separator: {
    marginTop: '0.5rem'
  },

  headers: {
    '& div:first-of-type': {
      borderTopLeftRadius: '4px'
    },

    '& div:last-of-type': {
      borderTopRightRadius: '4px'
    }
  },

  rowHeader: {
    backgroundColor: theme.palette.secondary.main,
    borderLeft: `solid 0.0625rem transparent`,
    borderRight: `solid 0.0625rem transparent`,
    color: theme.palette.primary.main,
    width: 250,
    fontSize: theme.size.sm,
    padding: '0.5rem',
    userSelect: 'none',
    flexShrink: 0
  }
}))

export default useStyles
